import React from "react";
import { Chip } from "@mui/material";
import { normalizeStatusValue, STATUS_COLOR_BY_VALUE, STATUS_COLORS } from "constants/projectRules";

export default function StatusChip({ value, size = "small" }) {
  const label = value || "Chưa cập nhật";
  const style = STATUS_COLOR_BY_VALUE[normalizeStatusValue(label)] || STATUS_COLORS.default;
  return (
    <Chip
      label={label}
      size={size}
      variant="outlined"
      sx={{
        height: 25,
        fontWeight: 600,
        fontSize: 10,
        color: style.color,
        backgroundColor: style.background,
        borderColor: style.border,
      }}
    />
  );
}
